import { render, staticRenderFns } from "./WarningDetailDialog.vue?vue&type=template&id=c2a8712e&scoped=true"
import script from "./WarningDetailDialog.vue?vue&type=script&lang=js"
export * from "./WarningDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./WarningDetailDialog.vue?vue&type=style&index=0&id=c2a8712e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a8712e",
  null
  
)

export default component.exports